module.exports = __webpack_public_path__ + "static/img/弹窗-水质.b9dc7ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/comp/弹窗-水质.png
// module id = q8kX
// module chunks = 3